import React from 'react';
import './App.css';

import MainLayout from './layouts/MainLayout';

import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import Header from './layouts/Header';

//import 'ant-design-pro/dist/ant-design-pro.min.css';

//import Error, { ErrorLevel } from './components/Error/Error';
import './components/Error/Error.css';
import { useKeycloak } from '@nic-react/auth';
import { useTranslation } from '@nic-react-i18n/core';
import { Dashboard } from './controllers/Dashboard';
import { AppRestrictions } from './configuration/permission/AppRestriction';
import Spinner from './components/Spinner/Spinner';
import NewRequestsController from './controllers/NewRequestsController';
import RequestController from './controllers/RequestController';
import { AbilityProvider } from './context/Authorization';
import CalendarController from './controllers/CalendarController';
import { ConfigProvider } from 'antd';

// import Home from './containers/Home';
// import ReservedRedirect from './routes/ReservedRedirect';
import itIT from 'antd/lib/locale/it_IT';
import enEN from 'antd/lib/locale/en_GB';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import 'dayjs/locale/en';
import utc from 'dayjs/plugin/utc';

import timezone from 'dayjs/plugin/timezone';
import BookingCalendarController from './controllers/registrar/BookingCalendarController';

dayjs.extend(utc)
dayjs.extend(timezone)

/*token: Keycloak.KeycloakInstance,
export const errorComponent = (title: string, error: string) => {

    return (
        <MainLayout
            components={{
                header: <Header/>,
                main: <Error
                    level={ErrorLevel.ERROR}
                    icon={'fa fa-exclamation-circle'}
                    iconColor={'red'}
                    title={title}
                    description={error}
                />
            }}
        />
    );
};
*/
const MainSwitch = () => {
    const {keycloak} = useKeycloak()
    //console.log('REALM: ', keycloak.realm)
    if (keycloak.realm === 'registrar') {
        return <Navigate to={'/requests'}/>
    } else {
        return <Navigate to={'/dashboard'}/>
    }
}


const useRouter = (): any => {
    return createBrowserRouter([
        {
            path: '/',
            children: [
                {
                    index: true,
                    element: <Navigate to={'/home'}/>
                },
                {
                  path: '/home',
                  element: useProtectedComponent(<MainSwitch/>)
                },
                {
                    path: '/dashboard',
                    element:
                        useProtectedComponent(<MainLayout components={{header: <Header/>, main: <Dashboard/>}}/>)

                },
                {
                    path: '/requests',
                    element: useProtectedComponent(<MainLayout components={{header: <Header/>, main: <NewRequestsController/>}}/>)
                },
                {
                    path: '/requests/:id/calendar/month/:year/:month',
                    element: useProtectedComponent(<MainLayout components={{header: <Header/>, main: <BookingCalendarController/>}}/>)
                },


                {
                    path: '/requests/:id',
                    element: useProtectedComponent(<MainLayout components={{header: <Header/>, main: <RequestController/>}}/>)
                },
                {
                    path: '/bookings/calendar/:period/:year?/:month?/:day?',
                    element: useProtectedComponent(<MainLayout components={{header: <Header/>, main: <CalendarController/>}}/>)
                }
            ]
        }

    ])
}

export const useProtectedComponent = (component: React.ReactElement<any>): React.ReactElement<any> => {
    const {initialized, keycloak, authenticated} = useKeycloak();
    React.useEffect(() => {

        if (initialized  && !authenticated) {
            keycloak.login();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialized])


    const resComp = (initialized && authenticated) ? component : <Spinner/> ;

    return (
        <>
            {resComp}
        </>
    )

}
export const App =  () => {

    const {locale} = useTranslation()

    dayjs.locale(locale)
    dayjs.tz.setDefault("Europe/Rome");

    return (
        <AbilityProvider restrictions={AppRestrictions}>
                <ConfigProvider locale={(locale === 'it' ? itIT: enEN)}>
                    <RouterProvider router={useRouter()}></RouterProvider>
                </ConfigProvider>
        </AbilityProvider>
    )
}